export default "__VITE_ASSET__90809451__"